// extracted by mini-css-extract-plugin
module.exports = {"login_signup_buttons_container":"FadeCatalog_login_signup_buttons_container__lpFlB"};